type PlaceholderProps = {
  text?: string;
  className?: string;
};

export const Placeholder = ({ text = 'Not Selected', className = 'font-medium text-base-20' }: PlaceholderProps) => (
  <span className={className}>{text}</span>
);
